import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/hero.css";

function Hero() {
  const navigate = useNavigate();

  const handleNavigate = (category) => {
    console.log("Category check", category)
    navigate("/product-list", { state: { category } })
  };

  return (
    <>
      <div className="hero">
        <div className="column"></div>
        <div className="column" style={{ backgroundColor: "transparent" }}></div>
      </div>

      <div className="hero-category">
        <div className="col" onClick={() => handleNavigate("Motorola")}>
          <div className="overlay"></div>
          <p>Top Collections</p>
          <h4>Motorola Radios</h4>
          <h5>Using Walkie Talkies to stay connected and communicate</h5>
          <button>Shop now</button>
        </div>

        <div className="col" onClick={() => handleNavigate("Hytera")}>
          <div className="overlay"></div>
          <p>Top Collections</p>
          <h4>Hytera Radios</h4>
          <h5>Compact and powerful Hytera walkie talkies for daily use</h5>
          <button>Shop now</button>
        </div>

        <div className="col" onClick={() => handleNavigate("ICOM")}>
          <div className="overlay"></div>
          <p>Top Collections</p>
          <h4>ICOM Radios</h4>
          <h5>Professional-grade ICOM communication devices</h5>
          <button>Shop now</button>
        </div>

        <div className="col" onClick={() => handleNavigate("Baofeng")}>
          <div className="overlay"></div>
          <p>Top Collections</p>
          <h4>Baofeng</h4>
          <h5>Budget-friendly Baofeng radios for casual use</h5>
          <button>Shop now</button>
        </div>
      </div>
    </>
  );
}

export default Hero;
